class PaymentMethod {
    constructor() {
        this.id = null;
        this.fusebillPaymentMethodId = null;
        this.method = null;
        this.maskedCardNumber = null;
        this.isDefault = null;
        this.cardType = null;
        this.firstName = null;
        this.lastName = null;
        this.expirationMonth = null;
        this.expirationYear = null;
    }
}

export { PaymentMethod };
